export default __webpack_public_path__ + "right-bg11b735e.png";